// src/app/useAdressizKatmanGeri.ts
//
// ─── ADRESSİZ KATMAN ↔ GERİ TUŞU (tek kanca) ────────────────────────────────
//
// Kararlar SAF katmanda (`adressizKatmanGeri.ts`); bu kanca yalnız onları
// `window.history` ve `popstate`e BAĞLAR. `useKartDetayUrl` ikilisiyle aynı
// bölünme — tek fark, burada **URL DEĞİŞMEZ**: `pushState(state, "",
// location.href)`. Yani adres çubuğu hiçbir şey iddia etmez, yalnız yığına
// geri tuşunun tüketeceği bir katman girdisi konur.
//
// ── NİYE İKİNCİ BİR KOPYA YAZILMADI ─────────────────────────────────────────
// Bu davranış repoda ZATEN üç yerde ayrı ayrı yazılmıştı (`BottomSheet`,
// `EditProfileSheet`, `ProfileMobile` aksiyon sheet'i) ve üçü de birbirinden
// biraz farklı. Dördüncü ve beşinci kopyayı yazmak yerine ortak kanca:
// mobil + masaüstü + mlv3 AYNI davranışı alır (`mekanUrlDevri`in dersi:
// ikizlerden biri güncellenip diğeri unutulunca kusur tek cihazda görünür).
//
// ── GERÇEK DAVRANIŞ ÖLÇÜLÜR ─────────────────────────────────────────────────
// Kanca ayrı olduğu için "aç → donanım geri → katman kapandı mı, sayfada
// kaldık mı" GERÇEK jsdom history ile ölçülüyor
// (`useAdressizKatmanGeri.render.test.tsx`) — kaynak metin taraması DEĞİL.

import { useCallback, useEffect, useRef } from "react";
import {
  adressizKatmanDurumu,
  adressizKapanistaPopla,
  adressizPopBizim,
} from "./adressizKatmanGeri";
import { enterSheet, exitSheet } from "../utils/sheetRouteGuard";

// ══════════════════════════════════════════════════════════════════════════
// 🔴 ÖLÇÜLDÜ (2026-09-01, GÖZ sahne `84-ilgilenmiyorum-geri-al`, gerçek
//    Chromium) — `stopImmediatePropagation()` BU KATMANI KORUMUYORDU.
//
// Aşağıdaki pop dinleyicisi `capture: true` + `stopImmediatePropagation()`
// ile kurulmuş ve yorumu *"global router bu pop'u GÖRMEMELİ"* diyordu.
// Gerçek koşuda ölçülen zincir (sonda: yamalı `history.*` + MutationObserver):
//
//   t=4145  akış `/c/clipB` yazar (replaceState, `mlv3:clip-shown`)
//   t=8602  "Daha fazla" sheet'i AÇILIR → bu kanca girdiyi pushlar (URL AYNI)
//   t=9083  "İlgilenmiyorum" satırı sheet'i kapatır → bu kanca `history.back()`
//   t=9083  popstate — bu kancanın dinleyicisi ÇALIŞIR (kapanış adresini geri
//           yazdığı ölçüldü) ve `stopImmediatePropagation()` atar
//   t=9155  `.clipmob__panel` DOĞAR ← global router `/c/clipB`yi SOĞUK DERİN
//           BAĞLANTI sanıp `openClipFromUrl` ile legacy klip modalını AÇTI
//
// SEBEP — DOM sözleşmesi: `popstate` doğrudan `window`a atılır, yani olay
// yolu tek elemanlıdır ve faz **AT_TARGET**'tır. AT_TARGET'ta `capture`
// bayrağı DİKKATE ALINMAZ; dinleyiciler **kayıt sırasına** göre koşar.
// Global router (`usePopstateHandler`) App mount'unda kaydolur — yani bu
// kancadan (sheet/kart mount'u) DAİMA ÖNCE. `stopImmediatePropagation()`
// yalnız HENÜZ ÇAĞRILMAMIŞ dinleyicileri durdurur → router'ı hiç durdurmaz.
// 🧭 Kanon: *"düşük yükte çalışan koruma"*nın SIRA hâli — koruma vardı,
// yazılıydı, testleri vardı; yalnız koruması gereken dinleyiciye hiç
// ULAŞMIYORDU.
//
// ÇÖZÜM — SIRADAN BAĞIMSIZ, ZATEN VAR OLAN MEKANİZMA: `sheetRouteGuard`
// sayacı. `usePopstateHandler`in İLK satırı `if (isSheetRouteActive()) return;`
// — yani sayaç yukarıdayken router, kayıt sırasından bağımsız olarak susar.
// `BottomSheet` bu sayacı aynı sebeple zaten tutuyor; burada İKİNCİ bir
// mekanizma icat edilmedi, var olanına bağlanıldı.
//
// ⚠️ `stopImmediatePropagation()` KALDIRILMADI: SONRA kaydolan dinleyiciler
// (ör. `MyClipsV3Gate`in profil pop'u — katmanla aynı ağaçta mount olur) için
// hâlâ çalışır. Kaldırmak ölçülmemiş bir davranış deltası olurdu.
// ══════════════════════════════════════════════════════════════════════════

/**
 * Kapanıştan sonra router susturmasının AÇIK KALDIĞI süre (ms).
 *
 * NİYE ZAMANLAYICI, NİYE KENDİ POP DİNLEYİCİMİZDE BIRAKMIYORUZ: bırakma
 * noktası kendi dinleyicimiz olsaydı kusurun TA KENDİSİ olan sıra sorununa
 * geri düşerdik — dinleyicimiz router'dan ÖNCE koşarsa sayacı düşürür ve
 * router yine çözer. Zamanlayıcı dispatch turunun tamamını kapsar ve pop hiç
 * gelmese bile sayacın SIZMASINI engeller (sızan +1 = global router'ın
 * popstate'i kalıcı olarak ölür — kapının 3. susturma yolu tam bunu ölçer).
 *
 * 300 ms uydurulmadı: `BottomSheet` aynı sayacı kapanış animasyonu boyunca
 * (300 ms) tutuyor — aynı sözleşme, aynı pencere. Bu turda ölçülen gerçek
 * gecikme ~23 ms'ti (kapanış t≈9060 → pop t=9083).
 */
const KAPI_SALIVERME_MS = 300;

export type AdressizKatmanGeriSecenekleri = {
  /** Katman şu an açık mı. */
  acik: boolean;
  /** Damga (`ADRESSIZ_ETIKET`) — iki katman aynı girdiyi sahiplenmesin. */
  etiket: string;
  /**
   * Geri tuşu girdimizi tükettiğinde çağrılır (katman kapansın).
   * **Idempotent olmalı** — kendi `back()`imizden dönen pop'ta da çağrılır
   * (katman zaten kapalıdır; `setActionsOpen(false)` / `setLastDrop(null)`
   * gibi setter'lar bunu karşılar).
   */
  onKapat: () => void;
};

export type AdressizKatmanGeriKolu = {
  /**
   * Girdiyi YENİDEN AL: geri tuşu girdimizi tükettikten SONRA, katman hâlâ
   * açıkken taze bir girdi push'lar. Idempotent — girdi zaten duruyorsa
   * (ya da katman kapalıysa) hiçbir şey yapmaz.
   *
   * ── NİYE VAR (ölçülmüş boşluk: ÇOK ADIMLI katman) ────────────────────
   * Kancanın taşıdığı model "bir katman = BİR girdi = BİR geri"dır ve tek
   * ekranlı sheet'ler için doğrudur. `WelcomeWizard` ise **5 adımlı** TEK
   * bir katmandır ve doğru davranış geri tuşunda ÖNCEKİ ADIM'a dönmektir.
   * Tek girdiyle ilk geri adımı geri alır, İKİNCİ geri artık girdisiz kalır
   * ve ALTTAKİ sayfayı tüketir — yani kusur bir basış GEÇ görünür (test
   * eden ilk basışta "çalışıyor" görür; kanonun "düşük yükte çalışan
   * koruma" dersinin geri-tuşu hâli).
   *
   * ⚠️ Girdiyi dışarıdan `history.pushState` ile koymak ÇÖZÜM DEĞİLDİR:
   * kancanın `pushladikRef`i `false` kalır → bir sonraki pop "bizim değil"
   * sayılır, `stopImmediatePropagation` atılmaz ve global router pop'u
   * sayfa gezintisi sanar. Girdinin sahibi TEK olmalıdır (bu kancanın kendi
   * sözleşmesi), o yüzden yeniden alma da BURADAN yapılır.
   *
   * ⚠️ "Adım başına bir kanca çağrısı" (5 girdi) ÖLÇÜLEREK ELENDİ: kapanışta
   * beşi de aynı tikte `adressizKapanistaPopla` sorar, `back()` ASENKRON
   * olduğu için yalnız en üstteki damgayı görür; alttakiler girdilerini
   * "devredilmiş" sayıp yığında BIRAKIR → sihirbaz kapandıktan sonra geri
   * tuşu birkaç kez hiçbir şey yapmaz.
   */
  girdiyiYenidenAl: () => void;
  /**
   * Girdiyi BIRAK: `back()` atmadan bayrağı düşür.
   *
   * Tek meşru kullanımı, katmanın kendisi bir SAYFA GEZİNTİSİ başlattığında
   * (`ProfileView.navigateMainApp`: `pushState(hedef)` + sentetik popstate).
   * O sentetik pop, React henüz render etmediği için `acik` hâlâ true iken
   * gelir; bırakmasaydık kanca onu BİZİM sanıp `stopImmediatePropagation()`
   * ile yutar ve gezinti hiç gerçekleşmezdi (ölçüldü: kancanın payda kolu).
   */
  girdiyiBirak: () => void;
};

export function useAdressizKatmanGeri({
  acik,
  etiket,
  onKapat,
}: AdressizKatmanGeriSecenekleri): AdressizKatmanGeriKolu {
  const onKapatRef = useRef(onKapat);
  onKapatRef.current = onKapat;
  const etiketRef = useRef(etiket);
  etiketRef.current = etiket;
  /**
   * ⚠️ RENDER SIRASINDA yazılır, effect'te DEĞİL. Sebep ölçülmüş: kapanış
   * effect'i `back()` çağırdığında pop ASENKRON gelir; o ana kadar "acık"
   * bilgisinin GÜNCEL olması gerekir, aksi halde `adressizPopBizim`
   * yanlış cevap verir.
   */
  const acikRef = useRef(acik);
  acikRef.current = acik;

  /** Yığında BİZİM girdimiz duruyor mu (çift `back()` = alt katmanı harcar). */
  const pushladikRef = useRef(false);
  /** `back()`i biz mi çağırdık — kapanış pop'unu tanımak için. */
  const kendiBackRef = useRef(false);
  /**
   * In-UI kapanışta adres çubuğunda DURMASI GEREKEN adres.
   *
   * ── NİYE (ölçülmüş sızıntı) ────────────────────────────────────────────
   * Katman AÇIKKEN başka bir kanca adres çubuğuna `replaceState` yazabilir ve
   * o yazma bizim girdimizin üstüne düşer. Ölçülen somut yol: `ProfileView`de
   * aksiyon sheet'inden "Kaydedilenler" seçilince aynı commit'te hem sheet
   * kapanır hem `changeTab("saved")` koşar; `useProfilSekmeUrl` (bu bileşende
   * BİZDEN ÖNCE bildirilmiş, yani effect'i önce koşar) `/{u}/saved` yazar —
   * ve ardından bizim `back()`imiz o adresi ÇÖPE ATARDI (sekme "saved",
   * adres çubuğu `/{u}` → URL/UI desync).
   * Sözleşme net: bu katmanın AÇILMASI da KAPANMASI da adres çubuğunu
   * DEĞİŞTİRMEZ. Kapanış pop'undan sonra adres, kapanış anındakine geri
   * yazılır. (Donanım geri tuşunda YAPILMAZ — orada alttaki adres DOĞRU
   * olandır; bu yüzden yalnız `kendiBack` kolunda.)
   */
  const kapanisAdresiRef = useRef<string | null>(null);

  // ── ROUTER SUSTURMA KAPISI (bkz. dosya başındaki ölçüm bloğu) ────────────
  /** Sayacı BİZ mi tutuyoruz? (çift `enterSheet` = kalıcı sızıntı) */
  const kapiRef = useRef(false);
  const kapiZamanRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const kapiBirak = useCallback(() => {
    if (kapiZamanRef.current != null) {
      clearTimeout(kapiZamanRef.current);
      kapiZamanRef.current = null;
    }
    if (!kapiRef.current) return;
    kapiRef.current = false;
    exitSheet();
  }, []);

  const girdiyiBirak = useCallback(() => {
    pushladikRef.current = false;
    kendiBackRef.current = false;
    kapanisAdresiRef.current = null;
    // ══════════════════════════════════════════════════════════════════════
    // 🔴 #1021 ÖLÇÜLDÜ (2026-09-02, GÖZ `86-katman-kapanisi-router`, GERÇEK
    //    CHROMIUM) — susturma sayacı BURADA da bırakılmalı.
    //
    // Bu kolun TEK meşru kullanımı, katmanın kendisi bir SAYFA GEZİNTİSİ
    // başlatmasıdır (`ProfileView.navigateMainApp`: `pushState(hedef)` +
    // SENTETİK popstate) ve orada router'ın UYANMASI İSTENİR. Ama yukarıdaki
    // `kapiAl()` katman GÖRÜNÜRKEN sayacı yukarıda tutuyor; `setActionsOpen
    // (false)` React state'i olduğu için sentetik pop, sayaç HÂLÂ yukarıdayken
    // geliyor → `usePopstateHandler`in ilk satırı erken dönüyordu.
    //
    // ÖLÇÜM (kendi profilin → ⋯ → "Klip Analitiğim"):
    //     adres = "/creator/clips"    ← `pushState` yazdı (router'sız da yazar)
    //     CreatorDashboard DOM = 0 · akış kartı = 7   ← SAYFA HİÇ AÇILMADI
    // 🧭 İlk ölçütüm yalnız ADRESE bakıyordu ve "router uyandı" diyordu; aynı
    //    turda iki kez düzelttiğim DAR ÖLÇÜT kusurunun üçüncü tekrarı.
    //    Adres, bir gezintinin kanıtı DEĞİLDİR.
    //
    // Girdiyi bırakmak "bu pop artık bizim değil" demektir; o hâlde susturmayı
    // da bırakmak gerekir — aksi hâlde kanca, kapatmak için var olduğu katmanın
    // DIŞINDAKİ bir gezintiyi öldürür. Kapanış kolları (`kapiGecikmeliBirak`)
    // DEĞİŞMEDİ: orada pencere hâlâ pop'u kapsıyor.
    // ══════════════════════════════════════════════════════════════════════
    kapiBirak();
  }, [kapiBirak]);

  const kapiAl = useCallback(() => {
    // Bekleyen bir salıverme varsa iptal: katman kapanıp ANINDA yeniden
    // açılırsa (sheet zinciri) sayaç bir alt-tur boyunca düşmemeli.
    if (kapiZamanRef.current != null) {
      clearTimeout(kapiZamanRef.current);
      kapiZamanRef.current = null;
    }
    if (kapiRef.current) return;
    kapiRef.current = true;
    enterSheet();
  }, []);

  /** Kapanış: sayaç, kendi `back()`imizin pop'u geçtikten SONRA düşer. */
  const kapiGecikmeliBirak = useCallback(() => {
    if (!kapiRef.current) return;
    if (kapiZamanRef.current != null) clearTimeout(kapiZamanRef.current);
    kapiZamanRef.current = setTimeout(() => {
      kapiZamanRef.current = null;
      kapiBirak();
    }, KAPI_SALIVERME_MS);
  }, [kapiBirak]);

  /**
   * Girdiyi yığına koyan TEK gövde — hem açılış effect'i hem
   * `girdiyiYenidenAl` bunu çağırır. İkinci bir push kopyası yazmak, iki
   * yerde ayrışabilen bir "girdi nasıl doğar" tanımı üretirdi.
   */
  const girdiPushla = useCallback(() => {
    if (typeof window === "undefined") return;
    if (pushladikRef.current) return; // çift push guard'ı
    try {
      window.history.pushState(
        adressizKatmanDurumu(etiketRef.current, window.history.state),
        "",
        // ⚠️ URL AYNEN KORUNUR. Katmanın paylaşılabilir adresi YOK; adres
        // çubuğunu değiştirmek olmayan bir sayfayı iddia etmek olurdu.
        window.location.href,
      );
      pushladikRef.current = true;
      kendiBackRef.current = false;
    } catch (_) {
      pushladikRef.current = false; // history yoksa katman yine de çalışır
    }
  }, []);

  const girdiyiYenidenAl = useCallback(() => {
    // Kapalı katman girdi ALMAZ: alırsa kapanıştan sonra yığında sahipsiz
    // bir girdi kalır ve geri tuşu "hiçbir şey yapmaz" olur.
    if (!acikRef.current) return;
    girdiPushla();
  }, [girdiPushla]);

  // ── AÇ / KAPA ────────────────────────────────────────────────────────────
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (acik) {
      girdiPushla();
      // Katman GÖRÜNÜRKEN global router susar (bkz. dosya başındaki blok).
      // Sıra GEREKTİRMEZ: `usePopstateHandler`in ilk satırı sayacı okur.
      kapiAl();
      return;
    }
    // Kapanışın HER kolunda sayaç düşer — ama HEMEN değil: kendi `back()`
    // pop'umuz asenkron gelir ve router o pop'ta susmuş olmalıdır.
    kapiGecikmeliBirak();
    // In-UI kapanış: kendi girdimizi TÜKET. Yalnız `replaceState`/hiçbir şey
    // yapmamak, girdiyi yığında bırakırdı → kullanıcı X'e basıp kapattıktan
    // sonra geri tuşu HİÇBİR ŞEY yapmazdı (`kartKapanistaPopla`da ölçülmüş
    // wart'ın aynısı).
    if (
      adressizKapanistaPopla(
        pushladikRef.current,
        window.history.state,
        etiketRef.current,
      )
    ) {
      // ⚠️ BAYRAK BURADA DÜŞÜRÜLMEZ: pop'u kendi dinleyicimiz tanımalı ve
      // `stopImmediatePropagation` ile alt katmanlardan (Gate/router)
      // saklamalı. `EditProfileSheet`te ölçülmüş hatanın tersi: bayrağı erken
      // düşürmek pop'u "bizim değil" yapar → girdi yenir, katman kapanmaz.
      kendiBackRef.current = true;
      kapanisAdresiRef.current = window.location.href;
      try {
        window.history.back();
      } catch (_) {
        pushladikRef.current = false;
        kendiBackRef.current = false;
        kapanisAdresiRef.current = null;
      }
      return;
    }
    // Girdi DEVREDİLDİ (üstümüze başka bir katman push'ladı) → dokunma.
    pushladikRef.current = false;
    kendiBackRef.current = false;
    kapanisAdresiRef.current = null;
  }, [acik, girdiPushla, kapiAl, kapiGecikmeliBirak]);

  // ── GERİ TUŞU ────────────────────────────────────────────────────────────
  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const onPop = (e: PopStateEvent) => {
      if (
        !adressizPopBizim(
          pushladikRef.current,
          acikRef.current,
          kendiBackRef.current,
        )
      ) {
        return;
      }
      const adres = kapanisAdresiRef.current;
      pushladikRef.current = false;
      kendiBackRef.current = false;
      kapanisAdresiRef.current = null;
      // capture + stopImmediatePropagation: `MyClipsV3Gate`in popstate
      // dinleyicisi (profil overlay'ini kapatır) ve global router bu pop'u
      // GÖRMEMELİ — pop "katmanı kapat" demektir, sayfa gezintisi DEĞİL.
      // (`EditProfileSheet`in kanıtlanmış deseni.)
      try { e.stopImmediatePropagation(); } catch (_) {}
      // In-UI kapanış adres çubuğunu OYNATMAZ: katman açıkken başka bir kanca
      // `replaceState` yazmış olabilir (ör. `useProfilSekmeUrl` → `/{u}/saved`)
      // ve `back()` o adresi çöpe atardı.
      //
      // ⚠️ BURADA `kendiBackRef` KAPISI YOK — ve bu bilerek. İlk yazımda vardı
      // (`kendiKapanis && adres && …`); mutasyon ölçümünde (M10) kapıyı SİLMEK
      // hiçbir testi öldürmedi, çünkü ULAŞILAMAZDI: `kapanisAdresiRef` YALNIZ
      // in-UI kapanış dalında doluyor, donanım geri tuşunda `null` kalıyor →
      // `adres` kontrolü zaten aynı ayrımı yapıyor. Ateşlenemeyen bir koruma,
      // koruma değil "yeşil ama anlamsız" bir satırdır (`useKartDetayKatmani`
      // kayıtlı dersinin aynısı).
      if (adres && window.location.href !== adres) {
        try {
          window.history.replaceState(window.history.state, "", adres);
        } catch (_) { /* adres kozmetik — katman yine kapanır */ }
      }
      try { onKapatRef.current?.(); } catch (_) {}
    };
    window.addEventListener("popstate", onPop, true);
    return () => window.removeEventListener("popstate", onPop, true);
  }, []);

  // ── UNMOUNT ──────────────────────────────────────────────────────────────
  // Katman prop/parent kapanışıyla (popstate olmadan) gitti → girdimiz yığında
  // kalırdı; bir sonraki geri tuşu "hiçbir şey yapmaz" olurdu.
  useEffect(
    () => () => {
      if (typeof window === "undefined") {
        kapiBirak();
        return;
      }
      if (!pushladikRef.current) {
        // Girdi yok → beklenecek bir pop da yok; sayacı ANINDA bırak.
        kapiBirak();
        return;
      }
      pushladikRef.current = false;
      kendiBackRef.current = false;
      // Girdi var → aşağıdaki `back()` bir pop üretir; sayaç o pop'tan SONRA
      // düşmeli (yoksa unmount yoluyla kapanan katman router'ı yine uyandırır).
      kapiGecikmeliBirak();
      try { window.history.back(); } catch (_) { kapiBirak(); }
    },
    [kapiBirak, kapiGecikmeliBirak],
  );

  return { girdiyiYenidenAl, girdiyiBirak };
}

export default useAdressizKatmanGeri;
